import { useEffect, useState } from "react";
import $ from "jquery";
import { useSelector, useDispatch } from "react-redux";
import { getBanner } from "../../state/actions/staticActions";
import styles from "./styles.module.sass";
import agencyLogo from "../../static/images/primer_agencije_logo.png";
import {
  getRoomTypeFromTranslation,
  getTranslationValueByKey,
} from "../../utils";

const Banner = () => {
  const dispatch = useDispatch();
  const banner = useSelector((state) => state.staticValues.banner);
  const translations = useSelector((state) => state.staticValues.translations);
  const lang = useSelector((state) => state.staticValues.lang);

  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    dispatch(getBanner()).then(() => setLoaded(true));
  }, [dispatch]);

  useEffect(() => {
    if (loaded && banner?.length > 0) {
      $(function () {
        const maxLength = banner.length;

        const animateElement = (selector, animClass, delay = 7450) => {
          $(selector)
            .show()
            .addClass(animClass)
            .delay(delay)
            .queue(function () {
              $(this).removeClass(animClass);
              $(this).dequeue();
            });
        };

        function actions() {
          animateElement(".property_info", "fadeInRight");
          animateElement(".footer_bar", "bounceInDown");
          animateElement(".property_price", "fadeInRight");
          [".info1", ".info2", ".info3", ".info4"].forEach((selector) =>
            animateElement(selector, "fadeInRight")
          );
        }

        function set(id) {
          const newId = id > maxLength ? 1 : id;
          actions();
          $(`.set${newId}`)
            .show()
            .addClass("fadeIn")
            .delay(7500)
            .queue(function () {
              $(this).removeClass("fadeIn");
              $(this).dequeue();
            })
            .hide(0, () => logo(newId));
        }

        function logo(id) {
          animateElement(`.logo${id}`, "rollIn", 3000);
          animateElement(".agency_phone", "tada", 3000);
          $(`.logo_area${id}`)
            .show(0)
            .delay(3100)
            .hide(0, () => set(id + 1));
        }

        logo(1);
      });
    }
  }, [loaded, banner]);

  const translate = (field) => {
    const key = getTranslationValueByKey(field);
    return translations[key] ? translations[key][lang] : null;
  };

  const getBannerFromApi = () =>
    (banner || []).map((property, idx) => {
      const { property_info, description, id } = property;
      const {
        area,
        city,
        price,
        property_size,
        pictures,
        type,
        rooms,
        options,
        agencies,
      } = property_info || {};

      const agency = agencies?.[0];
      const imageUrl = pictures?.length ? pictures[0].path : null;
      const roomsNum = parseFloat(rooms) || 0;
      const cityName = typeof city === "object" ? city?.name : city;
      const fullPropertyUrl = `https://www.nekretnine-novisad.rs/property/${id}`;
      const structure = translations[getRoomTypeFromTranslation(roomsNum)]
        ? translations[getRoomTypeFromTranslation(roomsNum)][lang]
        : null;
      const placStructure =
        type === "plac" ? translate(options?.property_sub_type) : null;
      const shouldShowStructure =
        type !== "stan" && (roomsNum === 0 || roomsNum === 0.5);

      return (
        <div key={id}>
          <a href={agency?.url || "#"} target="_blank">
            <div
              className={`banner_set logo_area logo_area${idx + 1}`}
              style={{ display: "none" }}
            >
              <img
                src={agency?.picture || agencyLogo}
                className={`animated banner_logo logo${idx + 1}`}
              />
              <p
                className="animated agency_phone"
                style={{ marginBottom: "20px" }}
              >
                {agency?.tel1 || "021/300-0300"}
              </p>
              <p className="agency_address" style={{ marginBottom: "20px" }}>
                {agency?.address || "Novi Sad"}
              </p>
              <p className="legal_info">
                NS-GROUP Nekretnine d.o.o., Novi Sad, Reg.br. 711
              </p>
            </div>
          </a>
          <a href={fullPropertyUrl} target="_blank">
            <div
              className={`banner_set set set${idx + 1} animated fadeIn`}
              style={{ display: "none" }}
            >
              <div className={`banner_bg bg_set${idx + 1}`}>
                <img src={imageUrl} alt={description} />
              </div>
              <div className="property_info_box">
                <span className="animated property_info fadeInRight">
                  {description}
                </span>
                <p className="animated pDelay property_price fadeInRight">
                  {price}€
                </p>
                <div className="property_other_info_wrapp">
                  <p className="animated pDelay2 property_other_info info1 fadeInRight">
                    {property_size} m2
                  </p>
                  <p className="animated pDelay3 property_other_info info2 fadeInRight">
                    {type}
                  </p>
                  <p className="animated pDelay4 property_other_info info3 fadeInRight">
                    {(type !== "plac" && !shouldShowStructure) || placStructure
                      ? placStructure
                        ? placStructure
                        : structure
                      : null}
                  </p>
                  <p className="animated pDelay5 property_other_info info4 fadeInRight">
                    {area}
                  </p>
                </div>

                <span className="animated footer_bar bounceInDown">
                  Pogledajte više informacija »
                </span>
              </div>
            </div>
          </a>
        </div>
      );
    });

  return (
    <div className={styles.container}>
      <div className="banner_box">{getBannerFromApi()}</div>
    </div>
  );
};

export default Banner;
